import { render, staticRenderFns } from "./powerList.vue?vue&type=template&id=57fc9dec&scoped=true&"
import script from "./powerList.vue?vue&type=script&lang=js&"
export * from "./powerList.vue?vue&type=script&lang=js&"
import style0 from "./powerList.vue?vue&type=style&index=0&id=57fc9dec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fc9dec",
  null
  
)

export default component.exports